module.exports = __webpack_public_path__ + "img/cat.a780ea03.png";